import React from 'react';
import { theme } from '../theme';
import { useLanguage } from '../i18n/useLanguage';
import pdfUrl from '../assets/C3A_Cloud_Computing_Autonomy.pdf';

/**
 * Download button/link for the C3A Framework PDF.
 * Label is i18n-aware (German / English).
 */
export const C3ADownloadButton: React.FC = () => {
  const { language } = useLanguage();

  const label =
    language === 'de'
      ? 'C3A Framework herunterladen'
      : 'Download C3A Framework';

  return (
    <a
      href={pdfUrl}
      download="C3A_Cloud_Computing_Autonomy.pdf"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 14px',
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 3,
        border: `1px solid ${theme.border}`,
        background: '#fff',
        color: theme.text,
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'background 0.2s',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLAnchorElement).style.background = theme.cardBg;
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLAnchorElement).style.background = '#fff';
      }}
    >
      <span aria-hidden="true">⬇</span>
      {label}
    </a>
  );
};
